import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useAuth } from "@/context/AuthContext";
import { useToastContext } from "@/context/ToastContext";
import { isAllTrue } from "@/utils/arrays";
import ButtonSecondary from "../../buttons/ButtonSecondary/ButtonSecondary";
import { GoogleIcon } from "../../icons/google";
import { UserIcon } from "../../icons/user";
import InputEmail from "../../Inputs/InputEmail/InputEmail";
import InputPassword from "../../Inputs/InputPassword/InputPassword";
import InputText, {
  initialText,
  TextState,
} from "../../Inputs/InputText/InputText";
import { Separator } from "../Separator/Separator";
import { SignUpWithMicrosoft } from "../SocialSignUp/SignUpWithMicrosoft";
import styles from "./RegisterForm.module.scss";

export const RegisterForm = () => {
  const router = useRouter();
  const { registerWithEmailAndPassword, loginWithGoogle } = useAuth();
  const { showSuccessAlert } = useToastContext();

  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [name, setName] = useState<TextState>(initialText);
  const [email, setEmail] = useState<TextState>(initialText);
  const [password, setPassword] = useState<TextState>(initialText);

  const [formValid, setFormValid] = useState(false);

  useEffect(() => {
    setFormValid(
      (name.value &&
        isAllTrue(name.validators) &&
        email.value &&
        isAllTrue(email.validators) &&
        password.value &&
        isAllTrue(password.validators)) ||
        false
    );
  }, [name, email, password]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const user = {
      name: name.value,
      email: email.value,
      password: password.value,
    };
    setLoading(true);
    registerWithEmailAndPassword(user)
      .then(async () => {
        setLoading(false);
        await router.push("/generator");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleGoogleLogin = async () => {
    setGoogleLoading(true);
    loginWithGoogle()
      .then(async () => {
        window.location.href = "/generator";
      })
      .catch((error) => {
        console.error("[RegisterForm] Google signup error:", error);
        setGoogleLoading(false);
      });
  };

  return (
    <div className={styles.registerContainer}>
      <SignUpWithMicrosoft />
      <Separator />

      <div className="mb-4">
        <ButtonSecondary
          variant="white"
          size="lg"
          className="w-full"
          loading={googleLoading}
          disabled={googleLoading}
          onClick={handleGoogleLogin}
          text="Continue with Google"
          icon={<GoogleIcon />}
        />
      </div>

      <form>
        <div className="flex flex-col gap-2">
          <InputText
            id="inputTextUserName"
            text={name}
            setText={setName}
            isRequired={true}
            minValueLength={2}
            maxValueLength={50}
            placeholder={"Name"}
            iconLeft={<UserIcon />}
          />
          <InputEmail
            id="inputEmailRegister"
            label={"Email"}
            email={email}
            setEmail={setEmail}
          />
          <InputPassword
            id="inputPasswordRegister"
            password={password}
            setPassword={setPassword}
            disabled={false}
          />
        </div>

        <ButtonSecondary
          size="lg"
          className="w-full mt-8"
          disabled={!formValid}
          loading={loading}
          text={"Create account"}
          onClick={handleFormSubmit}
        />
      </form>

      <p className={`caption-1 white ${styles.caption}`}>
        By creating an account, you agree to our{" "}
        <a href="" className="app-link caption-1 grey">
          Terms of Service
        </a>{" "}
        and{" "}
        <a href="" className="app-link caption-1 grey">
          Privacy & Cookie Statement.
        </a>
      </p>
    </div>
  );
};
